import React from 'react';
import classnames from 'classnames'
import styles from './ClosePopup.module.scss';
import Button from '@/components/Button';

export default function Icon(props) {
	return <Button { ...props } className={ classnames(styles.closePopup, props.className) } />;
}
